/**
 *
 * Styles for Textarea
 *
 */

import styled, { css } from "styled-components";
import { key } from "styled-theme";
import { breakpoints, focusedState } from "root/libs/ui-styleguide/src";

export const StyledTextareaContainer = styled.div`
  ${(props) =>
    props.marginBottom ? `margin-bottom: ${props.marginBottom};` : ""};
`;

export const TextareaWrapper = styled.div`
  ${focusedState.focusWithinAllBorders};
  overflow: hidden;
  position: relative;
  display: block;
  border: 1px solid ${(props) => key(props.borderColor)};
  border-radius: var(--dui-size-radius-md);
  padding: var(--dui-size-space-1);

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "initial")};
  }

  &:focus-within {
    border-width: var(--dui-size-width-border-sm);
    padding: 0;

    label {
      font-weight: 800;
    }
  }

  @supports (display: grid) {
    grid-column: 1 / span 2;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    @supports (display: grid) {
      grid-column: unset;
    }

    textarea {
      padding-bottom: var(--gaq-size-space-7px);
    }
  }
`;

export const StyledTextarea = styled.textarea`
  padding: 0 var(--dui-size-space-5x) var(--dui-size-space-5x)
    var(--dui-size-space-5x);
  min-height: auto;
  height: ${(props) => props.height};
  width: ${(props) => (props.preventTextAndIconOverlap ? "90%" : "100%")};
  box-sizing: border-box;
  outline: 1px solid transparent;
  font-size: var(--dui-size-font-md);
  line-height: var(--dui-size-line-height-normal);
  background: transparent;
  appearance: none;
  border: none;
  display: block;
  resize: none;

  &:disabled {
    color: #505050;
    background: var(--dui-color-gray-300);
    border: 0;
  }
`;

export const StyledLabel = css`
  display: block;
  padding: var(--dui-size-space-5x) var(--dui-size-space-5x)
    var(--dui-size-space-2x) var(--dui-size-space-5x);
  color: ${(props) =>
    props.hasError ? "var(--dui-color-red-500)" : "var(--dui-color-black-500)"};
  line-height: 1;
`;

export const StyledSuccessIcon = css`
  position: absolute;
  right: 20px;
  bottom: 10px;
`;
